import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ImageUploader({ value, onChange, testid, aspect = "aspect-[4/3]" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = () => inputRef.current?.click();

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      const full = data.url.startsWith("http") ? data.url : `${BACKEND_URL}${data.url}`;
      onChange(full);
      toast.success("Image téléversée");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Échec du téléversement");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="space-y-2" data-testid={testid}>
      <div className={`relative ${aspect} w-full overflow-hidden rounded-xl border border-sand bg-ivory`}>
        {value ? (
          <img src={value} alt="" className="h-full w-full object-cover" />
        ) : (
          <div className="flex h-full items-center justify-center text-taupe/50 text-sm">Aucune image</div>
        )}
        <button type="button" onClick={pick} disabled={busy}
          className="absolute inset-x-0 bottom-0 flex items-center justify-center gap-2 bg-ink/70 py-2 text-sm text-white hover:bg-ink transition-colors"
          data-testid={`${testid}-upload`}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
          {busy ? "Téléversement…" : "Remplacer la photo"}
        </button>
      </div>
      <input
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="ou collez une URL d'image"
        className="w-full rounded-lg border border-sand bg-white px-3 py-2 text-xs text-ink outline-none focus:border-gold"
        data-testid={`${testid}-url`}
      />
      <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="hidden" onChange={handleFile} />
    </div>
  );
}
